import React from 'react';
import Button from './Styled/Button';

export default ({ label, ...props }) => (
  <Button variant="contained" color="primary" {...props}>
    {label}
  </Button>
);
